<div class="bg-dark text-white footer ">
    <div class="container">
        <div class="row py-4">
            <div class="col-6 col-md-4 col-xl-3">
                <div class="fs-4 mb-2 fw-bold ff-light pt-4">Servicios</div>
                <ul class="foot-menu-list ff-light">
                    <li><a href="servicio-tecnico/agendar-cita" class="text-white ff-light">Agendar cita</a></li>
                    <li><a class="text-white ff-light">Repuestos</a></li>
                </ul>
            </div>
            <div class="col-6 col-md-4 col-xl-3">
                <div class="fs-4 mb-2 fw-bold ff-light pt-4">Nosotros</div>
                <ul class="foot-menu-list ff-light">
                    <li><a href="/sucursales" class="text-white ff-light">Sucursales</a></li>
                    <li><a href="/contacto" class="text-white ff-light">Contátenos</a></li>
                </ul>
            </div>
            <div class="col-6 col-md-4 col-xl-3 desktop">
                <div class="fs-4 mb-2 fw-bold ff-light pt-4">Novedades</div>
                <ul class="foot-menu-list ff-light">
                    <li><a href="https://ofertas.yamaha.bo/" class="text-white ff-light">Ofertas</a></li>
                    <li><a href="https://noticias.toyosa.com/yamaha" target="_blank" class="text-white ff-light">Noticias</a></li>
                </ul>
            </div>
            <div class="col-12 col-md-4 col-xl-3">
                <div class="fs-4 mb-4 fw-bold ff-light pt-4">Síguenos</div>
                <div class="rrss mb-3">
                    <a href="https://www.facebook.com/YamahaBolivia"><img src="../../assets/icons/facebook.svg" class="icons-rrss"/></a>
                    <a href="https://www.instagram.com/yamahabolivia/"><img src="../../assets/icons/instagram.svg" class="icons-rrss"/></a>
                    <a href="https://www.youtube.com/@yamahaboliviaoficial/videos"><img src="../../assets/icons/youtube.svg" class="icons-rrss"/></a>
                    <a href="https://www.tiktok.com/@yamahabolivia"><img src="../../assets/icons/tiktok.svg" class="icons-rrss"/></a>
                </div>
                <a href="tel:591800175200" target="_blanck">
                    <img src="../../assets/icons/contact_center.png" class="icons-contact-center"/>
                </a>
            </div>
            
        </div>

    </div>
    <div class="d-block pb-4 ff-light">
        <div class="text-center foot-copy"> © 2025 Yamaha Bolivia Copyright. all rights reserved</div>
    </div>
</div>